import { useQuery } from "@tanstack/react-query";
import { generatePath, NavLink } from "react-router-dom";

import Card from "~/components/Card";
import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { INVOICE_DETAILS_PATH } from "~/constants/appRoutes.ts";
import { processedInvoiceQueries } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";

type Props = { reversedInvoiceId: string; };

const ReversedInvoiceCard = ({ reversedInvoiceId }: Props) => {
	const {
		data: reversedInvoiceData,
		isFetching: reversedInvoiceDataIsLoading,
	} = useQuery(processedInvoiceQueries.details(reversedInvoiceId));

	return <Card title="Stornierte Rechnung">
		{reversedInvoiceData &&
			<NavLink className="hover:text-secondary-500"
					 to={generatePath(INVOICE_DETAILS_PATH, { invoiceId: reversedInvoiceData.id })}>{reversedInvoiceData.invoiceNumber}</NavLink>
		}
		{reversedInvoiceDataIsLoading &&
			<div className="flex w-full items-center justify-center"><LoadingSpinner scale={0.8} /></div>}

	</Card>;
};

export default ReversedInvoiceCard;